<script setup>
    import axios from "axios";
    import {onMounted, ref} from 'vue'

    window.axios = require('axios');

    const props = defineProps({
        csrf: {
            type: String,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        file: {
            type: String,
            required: true
        }
    })

    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

    const submitted = ref(false),
          formElement = ref(null),
          downloadText = ref("Your download is available below")

    onMounted(() => {
        const cookieName = 'previouslySubmitted'

        // Split the document.cookie string into individual cookies
        const cookies = document.cookie.split(';');

        // Check if the desired cookie exists in the array of cookies
        const cookieExists = cookies.some(cookie => {
            const [name, value] = cookie.split('=');
            return name.trim() === cookieName && value.trim() !== '';
        });

        submitted.value = cookieExists
    })

    function validate($event) {
        $event.preventDefault()
        let url = "/!/forms/" + props.form.handle

        axios.post(url, new FormData(formElement.value))
            .then(response => {
                if ( response.data.success ) {
                    downloadText.value = "Thank you for your submission. Your download is available below"
                    submitted.value = true
                    setCookie('previouslySubmitted', 'true', 365); // Set a cookie that expires in 365 days
                }
            })
            .catch(error => console.log(error))
    }

    function setCookie(name, value, days) {
        let expirationDate = new Date(),
            cookieValue = encodeURIComponent(name) + '=' + encodeURIComponent(value)

        expirationDate.setDate(expirationDate.getDate() + days)
        cookieValue += '; expires=' + expirationDate.toUTCString();
        document.cookie = cookieValue;
    }
</script>

<template>
    <div>
        <transition name="form-fade">
            <form v-show="!submitted" :name="form.handle" ref="formElement" @submit="validate($event)" class="custom-form custom-form--hide-labels p-6 bg-white rounded-md">
                <input type="hidden" name="_token" :value="csrf">
                <input v-if="form.honeypot" type="text" :name="form.honeypot" class="honeypot hidden">
                <form-fields :fields="form.fields"></form-fields>
            </form>
        </transition>
        <transition name="download-fade">
            <div v-show="submitted" class="flex flex-col gap-8">
                <div class="rich-text-body">
                    <p class="text-cintra-orange dark:text-cintra-orange">{{ downloadText }}</p>
                </div>
                <div>
                    <a :href="file"
                       target="_blank"
                       class="gradient-button gradient-button--orange">
                        <span>Download</span>
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<style>
    .form-fade-enter-active,
    .form-fade-leave-active {
        @apply transition;
        @apply duration-500;
    }
    .form-fade-enter-from,
    .form-fade-enter,
    .form-fade-leave-to /* .form-fade-leave-active in <2.1.8 */ {
        @apply opacity-0;
        @apply absolute;
        @apply -translate-y-20;
    }
    .form-fade-enter-to {
        @apply opacity-100;
        @apply translate-y-0;
    }

    .download-fade-enter-active,
    .download-fade-leave-active {
        @apply transition;
        @apply duration-500;
    }
    .download-fade-enter-from,
    .download-fade-enter,
    .download-fade-leave-to /* .download-fade-leave-active in <2.1.8 */ {
        @apply opacity-0;
        @apply translate-y-20;
    }
    .download-fade-enter-to {
        @apply opacity-100;
        @apply translate-y-0;
    }
</style>
